<template>
    <div :class="this.$lang() == 1 ? 'container_content_zh' : 'container_content'">
       <div class="content-header">
            <span>{{ $t("new.title264") }}</span>
       </div>
       <div class="content">
            <div class="content-price">
                <span>{{ $t("new.title265") }}: {{outlineInfo.totalPrice > 0  ?  parseFloat(outlineInfo.totalPrice).toFixed(2)
                                        .toString().replace('.00', '')
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "-" }} {{ outlineInfo.totalPrice > 0  ?  '円' : ''}} </span>
                <span>（{{ $t("new.title278") }}）</span>
            </div>
            <div class="content-table">
                <table class="content-table-info">
                    <thead class="content-table-info_header">
                        <td>{{ $t("new.title266") }}</td>
                        <td>{{ $t("new.title267") }}</td>
                        <td>{{ $t("new.title268") }}</td>
                    </thead>
                    <tbody class="content-table-info_body">
                        <tr v-for="(item, key) in listCourseName" :key="key">
                            <td class="content-table-info_body-course_name">
                                <span>{{ item.courseName }}</span>
                            </td>
                            <td :class="item.price > 0 ? 'content-table-info_body-price' : 'content-table-info_body-price-free'">
                                <span v-if="item.price <= 0">-</span>
                                <span v-else>{{ $t("new.title121") }}{{ parseFloat(item.price).toFixed(2)
                                        .toString().replace('.00', '')
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                            </td>
                            <td class="content-table-info_body-date">
                                <span>{{ getStartDayEndDayfCourse() }}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
       </div>
       <div class="content-footer">
            <div class="payment-method-title">
                <span>{{ $t("new.title269") }}</span>
            </div>
            <div class="payment-method">
                <div class="payment-method-qr">
                    <div class="payment-method-qr_title">
                        <span>{{ $t("new.title270") }}</span>
                        <span>{{ $t("new.title285") }}</span>
                    </div>
                    <div class="payment-method-qr_img">
                        <img src="@/assets/WechatPay/WechatPay.png" alt="">
                    </div>
                </div>
                <div class="payment-method-tranfer">
                    <div class="payment-method-tranfer_title">
                        <span>{{ $t("new.title271") }}</span>
                    </div>
                    <div class="payment-method-tranfer_content">
                        <span>Bank　Name： THE　TAMA　SHINKIN　BANK　TOKYO, JAPAN</span>
                        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Branch：　KUNITACHI　Branch</span>
                        <span>Branch Address：1-9-52　NAKA　KUNITACHI　TOKYO　JAPAN</span>
                        <span>BANK　A／C　NO.:　005-0034318</span>
                        <span>Beneficiary’s　Name： SANRITSU</span>
                        <span>SWIFT(BIG)CODE：TAMAJPJT</span>
                        <span>{{ $t("new.title279") }}</span>
                    </div>
                </div>
            </div>
       </div>
    </div>
</template>

<script>
export default {
    props: {
        bank: Array
    },
    data() {
        return {
            outlineInfo: this.$route.query,
            listCourseName: eval("(" + this.$route.query.listCourseName + ")"),
        }
    },
    created() {
        this.getStartDayEndDayfCourse()
    },
    methods: {
        getStartDayEndDayfCourse() {
            const date = new Date();
            const startDate = this.formatDate(date.getFullYear(), date.getMonth() + 1)
            let endDate = ""
            if ((date.getMonth() + 4) > 12) {
                endDate = this.formatDate(date.getFullYear() + 1, (date.getMonth() + 4) - 12)
            } else {
                endDate = this.formatDate(date.getFullYear(), date.getMonth() + 4)
            }
            return startDate + "-" + endDate
        },
        formatDate(year, month) {
            const formattedDate = `${year}年${month < 10 ? '0' + month : month}月`;
            return formattedDate
        }
    }
}
</script>
<style scoped>
.container_content_zh {
    margin-top: 40px;
    font-size: 15px;
}
.container_content {
    margin-top: 40px;
    font-size: 16.3px;
}
.container_content_zh span,
.container_content_zh td{
    font-weight: bold;
    font-family: 'Microsoft JhengHei', sans-serif !important;
}
.container_content span,
.container_content td {
    font-family: 'MS Gothic', sans-serif !important;
}
.content-header {
    margin-bottom: 40px;
    text-align: center;
    font-size: 17px !important;
}

.content-price {
    display: flex;
    flex-direction: column;
}

.content-table {
    margin-top: 5px;
}

.content-table-info {
    width: 100%;
    border-collapse: collapse;
}

.content-table-info td{
    padding: 0 15px 10px 15px;
    border: 1px solid black;
    height: 30px;
}

.content-table-info_header {
    text-align: center;
}


.content-table-info_body-price {
    text-align: right;
    width: 28%;
}

.content-table-info_body-price-free {
    text-align: center;
    width: 28%;
}

.content-table-info_body-date {
    text-align: right;
    width: 36%;
}

.content-table-info_body-course_name {
    width: 36%;
}

.content-footer {
    margin-top: 30px;
}

.payment-method-tranfer_content {
    display: flex;
    flex-direction: column;
    margin-left: 25px;
}

.payment-method-tranfer_content span {
    margin-top: 10px;
}

.payment-method-qr_img {
    margin: 30px 0px 30px 100px;
}

.payment-method-qr_img img {
    width: 200px;
}

.payment-method-qr_title {
    margin-top: 4px;
    padding-left: 29px;
}

.payment-method-qr_title span {
    line-height: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/defineSelfCourse/exportInfoInvoiceToPdf/contentPdf.vue